import Interval from "./Interval";

export default class PluralizationRule {
    public interval: Interval;
    public text: string;

    constructor(interval: Interval, text: string) {
        this.interval = interval;
        this.text = text;
    }

    public get isDefault(): boolean {
        return this.interval.equals(Interval.default);
    }
}
